import api from "../api";

export interface SocialLink {
  created_at: string;
  icon: string;
  id: number;
  is_active: boolean;
  name: string;
  order: number;
  updated_at: string;
  url: string;
}

/**
 * Fetch active social links from the database
 */
export const fetchSocialLinks = async (): Promise<SocialLink[]> => {
  try {
    const res = await api.get("/social-links");
    return res.data.data || [];
  } catch (error) {
    console.error("Failed to fetch social links:", error);
    return [];
  }
};

/**
 * Add a new social link
 */
export const addSocialLink = async (
  data: Omit<SocialLink, "created_at" | "id" | "updated_at">,
): Promise<any> => {
  return api.post("/social-links", data);
};

/**
 * Update a social link
 */
export const updateSocialLink = async (
  id: number,
  data: Partial<SocialLink>,
): Promise<any> => {
  return api.put(`/social-links/${id}`, data);
};

/**
 * Delete a social link
 */
export const deleteSocialLink = async (id: number): Promise<void> => {
  await api.delete(`/social-links/${id}`);
};
